import React from 'react';
import { IconButton } from '~/components';

function ColumnsButton(props) {
  return <IconButton tooltip="Columns" icon="table-columns" {...props} />;
}

export default ColumnsButton;
